export enum ClientTypeClient {
  BankingInstitutions = 'BankingInstitutions',
  CentralGovernmentsAndCentralBanks = 'CentralGovernmentsAndCentralBanks',
  GovernmentRelatedEntities = 'GovernmentRelatedEntities',
  HighNetWorthIndividuals = 'HighNetWorthIndividuals',
  Individuals = 'Individuals',
  InstitutionalClients = 'InstitutionalClients',
  NonFinancialCorporations = 'NonFinancialCorporations',
  OtherFinancialInstitutions = 'OtherFinancialInstitutions',
  RegionalGovernmentsAndLocalAuthorities = 'RegionalGovernmentsAndLocalAuthorities',
}
